import React from 'react';
import PropTypes from 'prop-types';

const ToggleButtons = ({ name, options, value, onChange, labelClass, showInactiveOnly }) => {
  return (
    <div className="toggle-buttons">
      <span className="sr-only">Activating this element will cause content on the page to be updated</span>
      {
        options.map(item => {
          const isHidden = showInactiveOnly && item.value === value;
          return (
            <React.Fragment key={item.value}>
              <input type="radio" id={item.value} name={name} value={item.value} onChange={onChange} checked={item.value === value} />
              <label className={`${labelClass} ${isHidden ? 'hidden' : ''}`} htmlFor={item.value}>{item.label}</label>
            </React.Fragment>
          )
        })
      }
    </div>
  )
};

ToggleButtons.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
};

ToggleButtons.defaultProps = {
  labelClass: 'tertiary-button',
  showInactiveOnly: false,
};

export default ToggleButtons;



// WEBPACK FOOTER //
// ./src/components/shared/toggle-buttons/toggle-buttons.js